// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 管理端登录 POST /apiAdmin/auth/login */
export async function adminAuthControllerLogin(
  body: API.AdminLoginDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataAdminLoginDataDtoDto>("/apiAdmin/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前管理员及权限信息 GET /apiAdmin/auth/userInfo */
export async function adminAuthControllerGetUserInfo(options?: {
  [key: string]: any;
}) {
  return request<API.ResultDataAdminInfoDtoDto>("/apiAdmin/auth/userInfo", {
    method: "GET",
    ...(options || {}),
  });
}
